"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "formatCurrency", {
  enumerable: true,
  get: function get() {
    return _currency.formatCurrency;
  }
});
Object.defineProperty(exports, "createCurrencyMask", {
  enumerable: true,
  get: function get() {
    return _currency.createCurrencyMask;
  }
});
Object.defineProperty(exports, "currencyMaskOptions", {
  enumerable: true,
  get: function get() {
    return _currency.currencyMaskOptions;
  }
});
Object.defineProperty(exports, "abbreviateCurrency", {
  enumerable: true,
  get: function get() {
    return _currency.abbreviateCurrency;
  }
});
Object.defineProperty(exports, "formatDateDistance", {
  enumerable: true,
  get: function get() {
    return _date.formatDateDistance;
  }
});
Object.defineProperty(exports, "formatDateRelative", {
  enumerable: true,
  get: function get() {
    return _date.formatDateRelative;
  }
});
Object.defineProperty(exports, "formatDate", {
  enumerable: true,
  get: function get() {
    return _date.formatDate;
  }
});
Object.defineProperty(exports, "removeWhitespace", {
  enumerable: true,
  get: function get() {
    return _removeWhitespace["default"];
  }
});
Object.defineProperty(exports, "formatName", {
  enumerable: true,
  get: function get() {
    return _formatName["default"];
  }
});
Object.defineProperty(exports, "truncate", {
  enumerable: true,
  get: function get() {
    return _truncate["default"];
  }
});
Object.defineProperty(exports, "maskFormat", {
  enumerable: true,
  get: function get() {
    return _maskFormat["default"];
  }
});
Object.defineProperty(exports, "dashIt", {
  enumerable: true,
  get: function get() {
    return _dashIt["default"];
  }
});
exports.formatPhone = void 0;

var _currency = require("./currency");

var _date = require("./date");

var _removeWhitespace = _interopRequireDefault(require("./removeWhitespace"));

var _formatName = _interopRequireDefault(require("./formatName"));

var _truncate = _interopRequireDefault(require("./truncate"));

var _maskFormat = _interopRequireDefault(require("./maskFormat"));

var _dashIt = _interopRequireDefault(require("./dashIt"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * @deprecated use maskFormat instead
 * @type {Function}
 */
var formatPhone = _maskFormat["default"];
exports.formatPhone = formatPhone;